<template>
  <div>
    <matrix
      :images="galleryImages"
      :image-actions="true"
      :edit-enabled="editorEnabled"
      @edit="editImage"
      @delete="deleteImage"
      @openVisor="openGallery"
    />

    <editor
      v-if="editorEnabled && showEditor"
      :images="galleryImages"
      :imageSelected="selectedImage"
      @close="showEditor = false"
      @saved="updateImages"
      @error="showEditor = false"
    />

    <lightBox
      :images="galleryImages"
      ref="lightbox"
      :show-caption="true"
      :show-light-box="false"
      v-if="lightboxEnabled && showLightBox"
    />
  </div>
</template>

<script>
import Matrix from "./Matrix";
import Editor from "./PhotoEditor";
import LightBox from "vue-image-lightbox";

export default {
  name: "SimpleGallery",

  props: {
    lightboxEnabled: {
      type: Boolean,
    },
    editorEnabled: {
      type: Boolean,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    Matrix,
    LightBox,
    Editor,
  },

  computed: {
    attrs() {
      const { lightbox, editorEnabled, ...attrs } = this.$attrs;

      return attrs;
    },
  },

  methods: {
    updateImages(newImages) {
      this.galleryImages = newImages;
    },

    editImage(image, index) {
      this.selectedImage = image;
      this.showEditor = true;
    },

    deleteImage(image) {
      this.$emit("deletedImage", image);
    },

    openGallery(image, index) {
      this.$refs.lightbox.showImage(index);
    },
  },

  data() {
    return {
      showEditor: false,
      showLightBox: false,
      selectedImage: null,
      galleryImages: null,
    };
  },

  watch: {
    images: {
      immediate: true,
      handler(value = []) {
        this.galleryImages = value;
      },
    },
    galleryImages(value) {
      this.$emit("updatedImages", value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Outputs/Images/SimpleGallery.vue